import type { ColumnsType } from 'antd/es/table';
import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';
import NewTable from 'components/NewTable';
import CurrencyInputPrecision from 'components/CurrencyInputPrecision';
import { formatCurrency } from 'utils/formatCurrency';
import { IServicePrice } from 'features/settingStaff/services/types/api';
import Close from 'assets/Icons/close';
import colorTheme from 'constants/color';

type IStaffPricingTableProps = {
  data: IServicePrice[];
  onChangePrice: (serviceId: string, newPrice: number) => void;
  onDelete?: (serviceId: string) => void;
  selectedServiceIds?: string[];
  onSelectionChange?: (selectedServiceIds: string[]) => void;
};

const StaffPricingTable: React.FC<IStaffPricingTableProps> = ({
  data,
  onChangePrice,
  onDelete,
  onSelectionChange,
  selectedServiceIds,
}) => {
    
  const rowSelection = {
    selectedRowKeys: selectedServiceIds,
    onChange: (selectedKeys: React.Key[]) => {
      onSelectionChange?.(selectedKeys as string[]);
    },
  };

  const columns: ColumnsType<IServicePrice> = [
    {
      title: 'Service Name',
      dataIndex: 'serviceName',
      key: 'serviceName',
      align: 'left',
      render: (text) => <Text variant='H8'>{text}</Text>,
    },
    {
      title: 'Default Price',
      dataIndex: 'defaultPrice',
      key: 'defaultPrice',
      align: 'left',
      render: (text) => <Text variant='H8'>{formatCurrency(text)}</Text>,
    },
    {
      title: 'Custom Price',
      dataIndex: 'price',
      key: 'price',
      align: 'left',
      render: (text, record: IServicePrice) => (
        <CurrencyInputPrecision
          value={text}
          onChange={(value) => onChangePrice(record.serviceId, value)}
        />
      ),
    },
    {
      title: '',
      dataIndex: '',
      key: 'go',
      align: 'center',
      render: (_, record: IServicePrice) => (
        <button
          onClick={() => onDelete && onDelete(record.serviceId)}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <Close fill={colorTheme.v2_other_3} />
        </button>
      ),
    },
  ];

  return (
    <Container>
      <NewTable
        rowSelection={{
          ...rowSelection,
          columnWidth: 140,
        }}
        columns={columns}
        dataSource={data}
        rowKey={'serviceId'}
        pagination={false}
      />
    </Container>
  );
};

export default StaffPricingTable;

const Container = styled.div`
  .ant-checkbox-input {
    width: 36px;
    height: 36px;
  }
  .ant-checkbox-inner {
    width: 36px;
    height: 36px;

    &::after {
      zoom: 2;
    }
  }

  .ant-table-thead th.ant-table-cell {
    font-size: 20px;
  }
`;
